import { useEffect, useState } from "react";
import Results from "@/pages/Results";
import { submitStudy } from "@/lib/api";
import { TopBar } from "@/components/Layout";
import { makeDefaultInputs } from "@/lib/store";

const DEMO_INPUTS = {
  ...makeDefaultInputs(),
  profile: { function: "rssi", objective: "reduce_risk", horizon: "3_6" },
  company: { sector: "Industrie", size: "s4", identities: 1450, criticality: "c3", hourly_downtime_cost: "d3", hourly_downtime_cost_value: 12500 },
  architecture: {
    forests: 1, domains: 2, dcs: 4, deployment: "hybrid",
    multi_entity: "no", trusts: "no", adfs: "no", adcs: "no",
    entra_connect: "yes", separate_admin_accounts: "partial",
    privileged_accounts: 18, service_accounts: 45, external_admins: 6,
    test_env: "partial", log_retention: "unknown", advanced_audit: "partial",
  },
  hygiene: {
    answers: {
      h_domain_admins_limited: "partial", h_admin_separate_accounts: "no",
      h_dormant_accounts: "no", h_offboarding: "partial", h_service_owner: "partial",
      h_service_no_privileges: "no", h_technical_passwords_rotated: "partial",
      h_service_interactive: "unknown", h_gpo_documented: "partial", h_gpo_monitored: "no",
      h_delegations_reviewed: "no", h_nested_groups: "no", h_shadow_admins: "no",
      h_adcs_audited: "unknown", h_legacy_protocols: "partial", h_mfa_entra: "partial",
      h_hybrid_risks: "no", h_remediation_tracked: "no",
    },
  },
  monitoring: {
    answers: {
      m_alert_domain_admins: "manual", m_detect_short_elevation: "absent",
      m_who_deleted: "manual", m_before_after: "absent",
      m_lockout_origin: "partial", m_failed_logins: "manual",
      m_offhours: "absent", m_audit_policy: "absent",
      m_account_creation: "manual", m_state_in_time: "absent",
      m_admin_history: "manual", m_central_history: "partial",
      m_auditor_reports: "manual", m_soc: "partial",
    },
    weekly_hours_ad: 18,
  },
  compliance: {
    frameworks: ["ISO/IEC 27001", "NIS2"],
    audits_per_year: 2, audit_hours: 60, auditor_ad_hoc_hours: 60,
    people_involved: 4, manual_evidence: "yes", past_findings: "yes",
    insurance_requirements: "yes", iam_pam_required: "yes",
    reports_available: "no", continuous_evidence: "no",
  },
  roi: {
    hourly_rate: 75, weekly_monitoring_hours: 18, audit_hours_per_year: 120,
    auditor_ad_hoc_hours: 60, investigations_per_year: 18,
    investigation_hours_current: 8, investigation_hours_target: 1,
    incidents_3_years: 1, avg_incident_cost: 500000,
    annual_incident_probability: 0.25, risk_reduction_pct: 0.20,
    analysis_years: 3, discount_rate: 0.08, identity_growth_pct: 0.05,
    run_cost_annual: 0, internal_mobilization_cost: 0,
    insurance_premium_reduction: 0, weeks_per_year: 47,
  },
};

const DEMO_LEAD = {
  firstName: "Exemple",
  lastName: "Ariovis",
  email: "exemple@ariovis.fr",
  phone: "",
  company: "Entreprise de services industriels",
  function: "rssi",
  consent: true,
};

export default function ExampleResult() {
  const [study, setStudy] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    submitStudy({ inputs: DEMO_INPUTS, lead: DEMO_LEAD })
      .then((s) => setStudy({ ...s, inputs: DEMO_INPUTS }))
      .catch((e) => setErr(e?.response?.data?.detail || e.message));
  }, []);

  if (err) return <div className="min-h-screen bg-slate-50"><TopBar /><div className="p-10 text-destructive">{String(err)}</div></div>;
  if (!study) return (
    <div className="min-h-screen bg-slate-50">
      <TopBar />
      <div className="p-10 text-slate-500">Chargement de l'exemple…</div>
    </div>
  );
  return <Results dataOverride={study} isExample={true} />;
}
